/**
 * StatTile — a single inline statistic (label eyebrow / value / unit).
 *
 * Dataviz stat-tile contract: the value uses PROPORTIONAL figures on purpose.
 * A standalone headline number set in tabular-nums reads loose and gappy;
 * proportional spacing keeps it tight and typographic. (Aligned columns of
 * numbers still use tabular-nums — see tableStyles.cellNum.)
 */
export function StatTile({ label, value, unit }: { label: string; value: string; unit?: string }) {
  return (
    <div className="min-w-[9rem] flex-1 rounded-lg border border-border bg-card px-5 py-4">
      <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </div>
      <div className="mt-1.5 text-2xl font-semibold tracking-tight text-foreground">{value}</div>
      {unit && <div className="mt-0.5 text-xs text-muted-foreground">{unit}</div>}
    </div>
  )
}
